import { useEffect, useState } from "react";
import logo from "../assets/MMK10.png";
import blankWhite from "../assets/blank_white.png";

const SignatureLoader = () => {
  const [a, setA] = useState(false);
  const [b, setB] = useState(false);
  const [c, setC] = useState(false);

  useEffect(() => {
    const interval = window.setInterval(() => {
      if (a === false) {
        setA((prevValueA) => {
          if (prevValueA === true) {
            setB((prevValueB) => {
              if (prevValueB === true) {
                setC((prevValueC) => {
                  if (prevValueC === true) {
                    setA(false);
                    setB(false);
                    setC(false);
                  }
                  return prevValueC === false;
                });
              }
              return true;
            });
          }
          return prevValueA === false;
        });
      } else if (b === false) {
        setB(true);
      } else if (c === false) {
        setC(true);
      } else if (a === true && b === true && c === true) {
        setA(false);
        setB(false);
        setC(false);
      }
    }, 555);

    return () => window.clearInterval(interval);
  }, []);

  return (
    <>
      <div>
        <div style={{ position: "relative", display: "flex", justifyContent: "center" }}>
          <div>
            <img src={logo} width="255px" alt="" className="mainLogo" />
            <img
              src={blankWhite}
              width="255px"
              alt=""
              className="mainLogoDuplicate"
              style={{ position: "absolute", top: 0, left: 0 }}
            />
          </div>
        </div>
      </div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "12em 5em",
          position: "relative",
          justifyContent: "left",
          gap: "2.5em",
        }}
      >
        <div style={{ display: "inline-grid", fontSize: "27px" }}>LOADING</div>
        <div className="loadingDots"> {a && "."}{b && "."}{c && "."}</div>
      </div>
    </>
  );
};

export default SignatureLoader;
